import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offline-sales',
  templateUrl: './offline-sales.component.html',
  styleUrls: ['./offline-sales.component.css']
})
export class OfflineSalesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
